import styled from 'styled-components';

export const Itens = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: space-around;
`;
